// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cULEKpIqppgCdv8CP7_n{border:1px solid var(--interaction-neutral-normal);background:var(--background-primary-inverted-primary);border-radius:6px}.cULEKpIqppgCdv8CP7_n:hover{border:1px solid var(--interaction-neutral-hovered);background-color:var(--background-primary-inverted-primary)!important}.OMy_iYuCrQwef6SU3Muy{box-sizing:border-box;height:40px;color:var(--content-neutral-primary);padding-top:11px;padding-left:11px}.Sifuyobgk4cLW0XtguV_,.Sifuyobgk4cLW0XtguV_:hover{border:none}.HYWqmyZ3Q0ZUFeJxWSqj{align-items:center;gap:8px;display:flex}.sBb9UEGZbMm8xprT6eNv{color:var(--content-primary-tertiary)}.lKNIrqmQSxYqbsWP4vjh{margin-top:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectTrigger": `cULEKpIqppgCdv8CP7_n`,
	"assignInboxTrigger": `OMy_iYuCrQwef6SU3Muy`,
	"selectTrigger_assignInboxError": `Sifuyobgk4cLW0XtguV_`,
	"selectTriggerAssignInboxError": `Sifuyobgk4cLW0XtguV_`,
	"assignInboxPlaceholder": `HYWqmyZ3Q0ZUFeJxWSqj`,
	"assignInboxPlaceholderIcon": `sBb9UEGZbMm8xprT6eNv`,
	"assignInboxError": `lKNIrqmQSxYqbsWP4vjh`
};
export default ___CSS_LOADER_EXPORT___;
